/**
 * LAROYE HATS — "BORN TO BE DIFFERENT"
 * Complete E-Commerce Engine & Shopping Experience
 */

const CONFIG = {
  shopify: {
    domain: 'laroye-hats.myshopify.com',
    storefrontAccessToken: '', // Daniel will add his dedicated Storefront Token here
    apiVersion: '2024-01'
  },
  itemsPerPage: 12,
  freeShippingThreshold: 150.00
};

// State
let allProducts = [];
let filteredProducts = [];
let currentCategory = 'all';
let currentStyle = 'all';
let currentBrand = 'all';
let currentHatType = 'all';
let currentTag = 'all';
let searchQuery = '';
let currentSort = 'featured';
let currentPage = 1;
let cart = [];
let selectedProduct = null;
let selectedSize = '7 3/8';
let isSamplerMode = false; // Full catalog visible and interactive by default

// ==========================================================================
// LAROYE HATS SIGNATURE RELEASES (BORN TO BE DIFFERENT)
// ==========================================================================
const LAROYE_CATALOG = [
  {
    id: "laroye-001",
    variantId: "laroye_var_001",
    name: "Nexus Streetwear Winged Crown Fitted",
    brand: "Laroye Hats",
    collection: "Signature",
    price: 68.00,
    oldPrice: 85.00,
    badge: "Exclusiva",
    inStock: true,
    scarcityText: "🔥 Only 3 Left In Vault",
    sizes: ["7 1/8", "7 1/4", "7 3/8", "7 1/2", "7 5/8", "7 3/4"],
    img: "assets/img/laroye_hat_black_red.jpg",
    images: ["assets/img/laroye_hat_black_red.jpg", "assets/img/laroye_logo.jpg"],
    description: "The flagship Laroye streetwear piece. Matte carbon twill with 3D high-density crimson embroidery, side metal eyelet vents, and polished chrome enamel pin."
  },
  {
    id: "laroye-002",
    variantId: "laroye_var_002",
    name: "Imperial Scepter Crown Snapback",
    brand: "Laroye Hats",
    collection: "Crown Series",
    price: 74.00,
    oldPrice: 90.00,
    badge: "Pre-Sale",
    isPresale: true,
    inStock: true,
    scarcityText: "⚡ Pre-Sale (Final Sale)",
    sizes: ["One Size Adjustable", "7 1/4", "7 3/8", "7 1/2"],
    img: "assets/img/laroye_hat_crown_red.jpg",
    images: ["assets/img/laroye_hat_crown_red.jpg", "assets/img/laroye_logo.jpg"],
    description: "Two-tone deep crimson red and onyx black structured cap featuring a high-relief polished chrome silver crown badge on the front panel. Note: Pre-sale item — custom-manufactured to order. Strictly no cancellations or returns."
  },
  {
    id: "laroye-003",
    variantId: "laroye_var_003",
    name: "Born to Be Different Trident Fitted",
    brand: "Laroye Hats",
    collection: "Signature",
    price: 65.00,
    oldPrice: null,
    badge: "New Release",
    inStock: true,
    scarcityText: "⚡ High Demand",
    sizes: ["7 1/4", "7 3/8", "7 1/2", "7 5/8"],
    img: "assets/img/laroye_logo.jpg",
    images: ["assets/img/laroye_logo.jpg", "assets/img/laroye_hat_black_red.jpg"],
    description: "Embossed circular crest emblem honoring the Laroye trident scepter and cowrie crown. Luxury satin-lined interior."
  },
  {
    id: "laroye-004",
    variantId: "laroye_var_004",
    name: "Midnight Velvet Blackout Fitted",
    brand: "ThirtyOne",
    collection: "Limited",
    price: 79.99,
    oldPrice: 95.00,
    badge: "Sale",
    inStock: true,
    scarcityText: "🔥 Selling Fast",
    sizes: ["7 1/4", "7 3/8", "7 1/2"],
    img: "assets/img/laroye_hat_black_red.jpg",
    images: ["assets/img/laroye_hat_black_red.jpg"],
    description: "Crushed midnight velvet crown with metallic chrome accents and crimson red contrast underbrim."
  },
  {
    id: "laroye-005",
    variantId: "laroye_var_005",
    name: "Tribal Key High-Crown Snapback",
    brand: "Bigg Boss",
    collection: "Crown Series",
    price: 59.00,
    oldPrice: null,
    badge: null,
    inStock: true,
    scarcityText: null,
    sizes: ["One Size Adjustable"],
    img: "assets/img/laroye_hat_crown_red.jpg",
    images: ["assets/img/laroye_hat_crown_red.jpg"],
    description: "Heavyweight wool-acrylic blend with custom metal clasp buckle and engraved insignia on side panel."
  },
  {
    id: "laroye-006",
    variantId: "laroye_var_006",
    name: "Red Scepter Streetwear Fitted",
    brand: "Dandy Hats",
    collection: "Signature",
    price: 68.00,
    oldPrice: 80.00,
    badge: "Sold Out",
    inStock: false,
    scarcityText: null,
    sizes: ["7 3/8", "7 1/2"],
    img: "assets/img/laroye_hat_black_red.jpg",
    images: ["assets/img/laroye_hat_black_red.jpg"],
    description: "Sold out vault piece. Re-stock notification list currently open for VIP members."
  },
  {
    id: "laroye-007",
    variantId: "laroye_var_007",
    name: "Arc-Tech Luminescent Circuit Snapback",
    brand: "ThirtyOne",
    collection: "Limited",
    price: 88.00,
    oldPrice: 110.00,
    badge: "Pre-Sale",
    isPresale: true,
    inStock: true,
    scarcityText: "⚡ Pre-Sale Drop",
    sizes: ["One Size Adjustable", "7 3/8", "7 1/2"],
    img: "assets/img/laroye_hat_cyber_red.jpg",
    images: ["assets/img/laroye_hat_cyber_red.jpg", "assets/img/laroye_hat_black_red.jpg"],
    description: "Futuristic streetwear snapback featuring luminescent crimson circuit traces and anodized chrome buckle. Note: Pre-sale item — custom-manufactured to order. Strictly no cancellations or returns."
  },
  {
    id: "laroye-008",
    variantId: "laroye_var_008",
    name: "Neo-Chrome Liquid Scepter Fitted",
    brand: "El Barbas",
    collection: "Crown Series",
    price: 95.00,
    oldPrice: 125.00,
    badge: "Neo-Drop",
    inStock: true,
    scarcityText: "⚡ 3D Liquid Metallurgy",
    sizes: ["7 1/4", "7 3/8", "7 1/2", "7 5/8"],
    img: "assets/img/laroye_neochrome_cap.jpg",
    images: ["assets/img/laroye_neochrome_cap.jpg", "assets/img/laroye_logo.jpg"],
    description: "Engineered neo-streetwear fitted cap featuring a 3D molten chrome scepter emblem, luminescent crimson piping accents, matte titanium ballistic twill, and laser-engraved underbrim."
  },
  {
    id: "laroye-009",
    variantId: "laroye_var_009",
    name: "Raw Underground 90s Block Party Fitted",
    brand: "JC Hats",
    collection: "Signature",
    price: 62.00,
    oldPrice: null,
    badge: "New Release",
    inStock: true,
    scarcityText: "🔥 Street Heat",
    sizes: ["7 1/8", "7 1/4", "7 3/8", "7 1/2", "7 5/8"],
    img: "assets/img/laroye_hat_vintage_street.jpg",
    images: ["assets/img/laroye_hat_vintage_street.jpg"],
    description: "Heavyweight wool vintage baseball cap with raised script embroidery and retro green underbrim."
  },
  {
    id: "laroye-010",
    variantId: "laroye_var_010",
    name: "Obsidian Minimal Architectural Cap",
    brand: "Sad Boyz",
    collection: "Signature",
    price: 75.00,
    oldPrice: 90.00,
    badge: null,
    inStock: true,
    scarcityText: "◻️ Studio Run",
    sizes: ["7 1/4", "7 3/8", "7 1/2"],
    img: "assets/img/laroye_hat_minimal_studio.jpg",
    images: ["assets/img/laroye_hat_minimal_studio.jpg"],
    description: "Brushed dark slate suede visor, matte carbon crown, and subtle silver front emblem."
  },
  {
    id: "laroye-011",
    variantId: "laroye_var_011",
    name: "The Chrome Scepter Crown Fitted",
    brand: "Laroye Hats",
    collection: "Crown Series",
    price: 68.00,
    oldPrice: 85.00,
    badge: "Spotlight Drop",
    inStock: true,
    scarcityText: "🔥 High Demand",
    sizes: ["7 1/8", "7 1/4", "7 3/8", "7 1/2", "7 5/8"],
    img: "assets/img/laroye_emblem_spotlight_cap.jpg",
    images: ["assets/img/laroye_emblem_spotlight_cap.jpg", "assets/img/laroye_logo.jpg"],
    description: "Features a prominent 3D polished chrome metallic emblem matching the Laroye royal crowned mask and crossed tridents crest."
  },
  {
    id: "laroye-012",
    variantId: "laroye_var_012",
    name: "Orisha Gold Scepter Velvet Fitted",
    brand: "Laroye Hats",
    collection: "Crown Series",
    price: 74.00,
    oldPrice: 95.00,
    badge: "Masterpiece",
    inStock: true,
    scarcityText: "👑 Royal Masterpiece",
    sizes: ["One Size Adjustable", "7 1/4", "7 3/8", "7 1/2"],
    img: "assets/img/laroye_gold_scepter_cap.jpg",
    images: ["assets/img/laroye_gold_scepter_cap.jpg", "assets/img/laroye_logo.jpg"],
    description: "Couture red velvet cap featuring hand-guided 24K gold bullion wire embroidery of the sacred cowrie crown and ceremonial Elegba key scepter."
  }
];

// ==========================================================================
// INITIALIZATION
// ==========================================================================
document.addEventListener('DOMContentLoaded', () => {
  initCart();
  initEventListeners();
  initBrandVideoObserver();
  loadCatalog();
});

async function loadCatalog() {
  allProducts = LAROYE_CATALOG;

  // Live Shopify Storefront API Sync (if Daniel's token is configured)
  if (window.ShopifyClient && window.ShopifyClient.accessToken) {
    try {
      const liveProducts = await window.ShopifyClient.fetchProducts(1000);
      if (liveProducts && liveProducts.length > 0) {
        allProducts = liveProducts;
        console.log(`[Shopify Storefront] Successfully synced ${liveProducts.length} live products from Shopify.`);
      }
    } catch (e) {
      console.warn('[Shopify Storefront] Using design catalog fallback:', e);
    }
  }

  initShopifyBrandsAndTypesUI();
  initSamplerCarousel();
  applyFilterAndRender();
  checkUrlHashForProduct();
}

/**
 * Detects City / Style from product tags or title keywords
 */
function detectStyleFromProduct(p) {
  if (!p) return 'Custom Editions';
  if (p.style && p.style !== 'all' && !p.style.toLowerCase().includes('l.a model')) return p.style;

  const title = p.name || p.title || '';
  const titleLower = title.toLowerCase();
  const tags = Array.isArray(p.tags) ? p.tags.map(t => (t || '').trim().toLowerCase()) : [];

  for (const t of tags) {
    if (
      t === 'la' || 
      t === 'l.a' || 
      t === 'l.a.' || 
      t.includes('l.a') || 
      t.includes('los angeles') || 
      t.includes('los ángeles') || 
      t.includes('la models') || 
      t.includes('dodgers')
    ) {
      return 'Los Angeles';
    }
    if (t === 'ny' || t === 'n.y' || t.includes('new york') || t.includes('yankees') || t.includes('mets')) return 'New York';
    if (t === 'sd' || t === 's.d' || t.includes('san diego') || t.includes('padres')) return 'San Diego';
    if (t === 'chicago' || t === 'chi' || t.includes('white sox') || t.includes('bulls')) return 'Chicago';
    if (t.includes('houston') || t.includes('texas') || t.includes('astros') || t.includes('dallas')) return 'Texas';
    if (t.includes('boston') || t.includes('red sox')) return 'Boston';
    if (t.includes('detroit') || t.includes('tigers')) return 'Detroit';
    if (t.includes('mexico') || t.includes('méxico')) return 'Mexico';
    if (t === 'equipos' || t.includes('equipo')) return 'Equipos';
  }

  if (
    titleLower.includes('los angeles') || 
    titleLower.includes('los ángeles') || 
    titleLower.includes('los angles') || 
    titleLower.includes('dodgers') ||
    (/\b(LA|L\.A)\b/.test(title) && !/\bLa\s+(Guadalupana|Santa|Muerte|Virgen|Banda)\b/i.test(title))
  ) {
    return 'Los Angeles';
  }
  if (/\b(NY|N\.Y)\b/.test(title) || titleLower.includes('new york') || titleLower.includes('yankees') || titleLower.includes('mets')) {
    return 'New York';
  }
  if (/\b(SD|S\.D)\b/.test(title) || titleLower.includes('san diego') || titleLower.includes('padres')) {
    return 'San Diego';
  }
  if (/\bCHI\b/.test(title) || titleLower.includes('chicago') || titleLower.includes('white sox')) {
    return 'Chicago';
  }
  if (titleLower.includes('houston') || titleLower.includes('astros') || titleLower.includes('texas') || titleLower.includes('dallas')) {
    return 'Texas';
  }
  if (titleLower.includes('boston') || titleLower.includes('red sox')) {
    return 'Boston';
  }
  if (titleLower.includes('detroit') || titleLower.includes('tigers')) {
    return 'Detroit';
  }
  if (titleLower.includes('mexico') || titleLower.includes('méxico')) {
    return 'Mexico';
  }

  return 'Custom Editions';
}

/**
 * Dynamically builds City / Style, Shopify Tags, and Hat Type filters from Shopify products
 */
function initShopifyBrandsAndTypesUI() {
  const brandPillsWrap = document.getElementById('shopifyBrandPills');
  const tagPillsWrap = document.getElementById('shopifyTagPills');
  const brandSelect = document.getElementById('brandSelect');

  const styleCounts = {
    'all': allProducts.length,
    'Los Angeles': 0,
    'New York': 0,
    'San Diego': 0,
    'Mexico': 0,
    'Texas': 0,
    'Chicago': 0,
    'Boston': 0,
    'Detroit': 0,
    'Custom Editions': 0
  };

  const seriesCounts = {
    'Cruces Series': 0,
    'Cristales Series': 0,
    'Religiosas Series': 0,
    'Anniversary Series': 0,
    'Special Editions': 0
  };

  const tagCounts = {};

  allProducts.forEach(p => {
    const s = detectStyleFromProduct(p);
    p.style = s;
    p.city = s;
    if (styleCounts[s] === undefined) {
      styleCounts[s] = 0;
    }
    styleCounts[s]++;

    const t = p.hatType || 'Special Editions';
    if (seriesCounts[t] === undefined) {
      seriesCounts[t] = 0;
    }
    seriesCounts[t]++;

    // Collect and count unique merchant tags
    if (Array.isArray(p.tags)) {
      p.tags.forEach(tag => {
        const cleanTag = (tag || '').trim();
        if (cleanTag) {
          tagCounts[cleanTag] = (tagCounts[cleanTag] || 0) + 1;
        }
      });
    }
  });

  const availableStyles = ['Los Angeles', 'New York', 'San Diego', 'Mexico', 'Texas', 'Chicago', 'Boston', 'Detroit', 'Custom Editions'];
  Object.keys(styleCounts).forEach(s => {
    if (s !== 'all' && !availableStyles.includes(s) && styleCounts[s] > 0) {
      availableStyles.push(s);
    }
  });

  // Helper to update text safely
  const setCount = (id, val) => {
    const el = document.getElementById(id);
    if (el) el.textContent = val;
  };

  // Update Navbar Dropdown count badges
  setCount('navCountAll', styleCounts['all']);
  setCount('navCountLA', styleCounts['Los Angeles'] || 0);
  setCount('navCountNY', styleCounts['New York'] || 0);
  setCount('navCountSD', styleCounts['San Diego'] || 0);
  setCount('navCountMexico', styleCounts['Mexico'] || 0);
  setCount('navCountTexas', styleCounts['Texas'] || 0);
  setCount('navCountChicago', styleCounts['Chicago'] || 0);
  setCount('navCountBoston', styleCounts['Boston'] || 0);
  setCount('navCountDetroit', styleCounts['Detroit'] || 0);
  setCount('navCountCustom', styleCounts['Custom Editions'] || 0);

  // Update Signature Series counts
  setCount('navCountCruces', seriesCounts['Cruces Series'] || 'Series');
  setCount('navCountCristales', seriesCounts['Cristales Series'] || 'Series');
  setCount('navCountReligiosas', seriesCounts['Religiosas Series'] || 'Series');
  setCount('navCountAnniversary', seriesCounts['Anniversary Series'] || 'Series');
  setCount('navCountSpecial', seriesCounts['Special Editions'] || 'Series');

  // Update Featured Tag badges in navigation
  setCount('navCountGalloFino', tagCounts['Gallo Fino'] || tagCounts['Gallos'] || 0);
  setCount('navCountSadBoyz', tagCounts['Sad Boyz'] || 0);
  setCount('navCountTagCruces', tagCounts['Cruces'] || 0);
  setCount('navCountTagBB', tagCounts['Bigg Boss modelos varios'] || 0);
  setCount('navCountTagCristo', tagCounts['Cristo Jesus'] || 0);
  setCount('navCountTagSanJudas', tagCounts['San Judas'] || 0);
  setCount('navCountTagVirgen', tagCounts['Virgencita'] || 0);
  setCount('navCountTagCT', tagCounts['Modelo CT'] || 0);
  setCount('navCountTagExodo', tagCounts['Exodo modelos'] || 0);
  setCount('navCountTagMarkitos', tagCounts['Markitos Toys'] || 0);

  // Update Mobile Drawer count badges
  setCount('mobCountAll', styleCounts['all']);
  setCount('mobCountLA', styleCounts['Los Angeles'] || 0);
  setCount('mobCountNY', styleCounts['New York'] || 0);
  setCount('mobCountSD', styleCounts['San Diego'] || 0);
  setCount('mobCountMexico', styleCounts['Mexico'] || 0);
  setCount('mobCountTexas', styleCounts['Texas'] || 0);
  setCount('mobCountCustom', styleCounts['Custom Editions'] || 0);

  // Update On-Page Hub total badge
  setCount('hubTotalCountBadge', `${styleCounts['all']} Caps`);

  // Render Style Pills in Collections Strip
  if (brandPillsWrap) {
    let pillsHtml = `
      <button class="brand-pill ${currentStyle === 'all' && currentTag === 'all' ? 'active' : ''}" data-style="all" data-brand="all">
        <span class="pill-name">All Styles</span>
        <span class="pill-count">${styleCounts['all']}</span>
      </button>
    `;

    availableStyles.forEach(styleName => {
      const count = styleCounts[styleName] || 0;
      if (count === 0 && styleName !== 'Los Angeles' && styleName !== 'New York' && styleName !== 'San Diego' && styleName !== 'Custom Editions') {
        return; // Skip 0 count extras
      }
      const displayName = styleName === 'Los Angeles' ? 'Los Angeles (LA)' :
                          styleName === 'New York' ? 'New York (NY)' :
                          styleName === 'San Diego' ? 'San Diego (SD)' :
                          styleName === 'Mexico' ? 'México' :
                          styleName === 'Texas' ? 'Houston / Texas' : styleName;
      pillsHtml += `
        <button class="brand-pill ${currentStyle.toLowerCase() === styleName.toLowerCase() && currentTag === 'all' ? 'active' : ''}" data-style="${escapeHtml(styleName)}" data-brand="${escapeHtml(styleName)}">
          <span class="pill-name">${escapeHtml(displayName)}</span>
          <span class="pill-count">${count}</span>
        </button>
      `;
    });

    brandPillsWrap.innerHTML = pillsHtml;

    brandPillsWrap.querySelectorAll('.brand-pill').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const s = e.currentTarget.getAttribute('data-style') || e.currentTarget.getAttribute('data-brand') || 'all';
        selectStyle(s);
      });
    });
  }

  // Render Dynamic Shopify Merchant Tag Pills
  if (tagPillsWrap) {
    const sortedTags = Object.keys(tagCounts).sort((a, b) => tagCounts[b] - tagCounts[a]);
    let tagHtml = `
      <button class="tag-pill ${currentTag === 'all' ? 'active' : ''}" data-tag="all">
        <span class="pill-name">All Tags</span>
        <span class="pill-count">${allProducts.length}</span>
      </button>
    `;

    sortedTags.forEach(tagName => {
      const count = tagCounts[tagName];
      const isActive = currentTag.toLowerCase() === tagName.toLowerCase() ? 'active' : '';
      let displayTag = tagName;
      if (tagName === 'Bigg Boss modelos varios') displayTag = 'BIGG BOSS';
      else if (tagName === 'Exodo modelos') displayTag = 'Éxodo';
      else if (tagName === 'Modelo CT') displayTag = 'Corridos Tumbados (CT)';
      else if (tagName === 'Pantera Modelos') displayTag = 'Pantera';
      else if (tagName === 'Detroit Modelos') displayTag = 'Detroit';
      else if (tagName === 'Cristo Jesus') displayTag = 'Cristo Jesús';

      tagHtml += `
        <button class="tag-pill ${isActive}" data-tag="${escapeHtml(tagName)}" title="${escapeHtml(tagName)} (${count})">
          <span class="pill-name">${escapeHtml(displayTag)}</span>
          <span class="pill-count">${count}</span>
        </button>
      `;
    });

    tagPillsWrap.innerHTML = tagHtml;

    tagPillsWrap.querySelectorAll('.tag-pill').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const t = e.currentTarget.getAttribute('data-tag') || 'all';
        selectTag(t);
      });
    });
  }

  // Update Style Select Dropdown in toolbar (No quantities shown)
  if (brandSelect) {
    let selectHtml = `<option value="all">All Styles</option>`;
    availableStyles.forEach(styleName => {
      const isSelected = currentStyle.toLowerCase() === styleName.toLowerCase() && currentTag === 'all' ? 'selected' : '';
      const displayName = styleName === 'Los Angeles' ? 'Los Angeles (LA)' :
                          styleName === 'New York' ? 'New York (NY)' :
                          styleName === 'San Diego' ? 'San Diego (SD)' :
                          styleName === 'Mexico' ? 'México' :
                          styleName === 'Texas' ? 'Houston / Texas' : styleName;
      selectHtml += `<option value="${escapeHtml(styleName)}" ${isSelected}>${escapeHtml(displayName)}</option>`;
    });
    brandSelect.innerHTML = selectHtml;
  }

  renderHatTypesSubFilter();
}

function selectStyle(styleName) {
  currentStyle = styleName;
  currentBrand = styleName;
  currentHatType = 'all';
  currentTag = 'all';
  currentPage = 1;

  const shopSec = document.getElementById('shop-sec');
  if (shopSec) shopSec.classList.add('revealed');

  const brandPillsWrap = document.getElementById('shopifyBrandPills');
  if (brandPillsWrap) {
    brandPillsWrap.querySelectorAll('.brand-pill').forEach(btn => {
      const s = btn.getAttribute('data-style') || btn.getAttribute('data-brand');
      btn.classList.toggle('active', (s === 'all' && styleName === 'all') || (s && s.toLowerCase() === styleName.toLowerCase()));
    });
  }

  const tagPillsWrap = document.getElementById('shopifyTagPills');
  if (tagPillsWrap) {
    tagPillsWrap.querySelectorAll('.tag-pill').forEach(btn => {
      btn.classList.toggle('active', btn.getAttribute('data-tag') === 'all');
    });
  }

  const brandSelect = document.getElementById('brandSelect');
  if (brandSelect) {
    brandSelect.value = styleName;
  }

  const statusEl = document.getElementById('brandFilterStatus');
  if (statusEl) {
    if (styleName === 'all') {
      statusEl.textContent = 'All Official Drops';
    } else {
      const disp = styleName === 'Los Angeles' ? 'Los Angeles (LA)' :
                   styleName === 'New York' ? 'New York (NY)' :
                   styleName === 'San Diego' ? 'San Diego (SD)' :
                   styleName === 'Mexico' ? 'México' :
                   styleName === 'Texas' ? 'Houston / Texas' : styleName;
      statusEl.textContent = `${disp} Releases`;
    }
  }

  renderHatTypesSubFilter();
  applyFilterAndRender();
  scrollToCatalogTop();
}

function selectTag(tagName) {
  currentTag = tagName;
  currentStyle = 'all';
  currentBrand = 'all';
  currentHatType = 'all';
  currentPage = 1;

  const shopSec = document.getElementById('shop-sec');
  if (shopSec) shopSec.classList.add('revealed');

  const tagPillsWrap = document.getElementById('shopifyTagPills');
  if (tagPillsWrap) {
    tagPillsWrap.querySelectorAll('.tag-pill').forEach(btn => {
      const t = btn.getAttribute('data-tag');
      btn.classList.toggle('active', (t === 'all' && tagName === 'all') || (t && t.toLowerCase() === tagName.toLowerCase()));
    });
  }

  const brandPillsWrap = document.getElementById('shopifyBrandPills');
  if (brandPillsWrap) {
    brandPillsWrap.querySelectorAll('.brand-pill').forEach(btn => {
      const s = btn.getAttribute('data-style') || btn.getAttribute('data-brand');
      btn.classList.toggle('active', s === 'all');
    });
  }

  const brandSelect = document.getElementById('brandSelect');
  if (brandSelect) {
    brandSelect.value = 'all';
  }

  const statusEl = document.getElementById('brandFilterStatus');
  if (statusEl) {
    let disp = tagName;
    if (tagName === 'Bigg Boss modelos varios') disp = 'BIGG BOSS';
    else if (tagName === 'Exodo modelos') disp = 'Éxodo';
    else if (tagName === 'Modelo CT') disp = 'Corridos Tumbados (CT)';
    statusEl.textContent = tagName === 'all' ? 'All Official Drops' : `Tag: ${disp}`;
  }

  const labelEl = document.getElementById('filterIndicatorLabel');
  if (labelEl) {
    let disp = tagName;
    if (tagName === 'Bigg Boss modelos varios') disp = 'BIGG BOSS';
    else if (tagName === 'Exodo modelos') disp = 'Éxodo';
    else if (tagName === 'Modelo CT') disp = 'Corridos Tumbados (CT)';
    labelEl.textContent = tagName === 'all' ? 'Viewing Collection: All Drops' : `Viewing Tag: ${disp}`;
  }

  renderHatTypesSubFilter();
  applyFilterAndRender();
  scrollToCatalogTop();
}
window.selectTag = selectTag;

// Backwards-compatible alias for any legacy links
function selectBrand(brand) {
  selectStyle(brand);
}

function renderHatTypesSubFilter() {
  const container = document.getElementById('hatTypesPillsContainer');
  if (!container) return;

  const styleProducts = allProducts.filter(p => {
    if (currentTag !== 'all') {
      return Array.isArray(p.tags) && p.tags.some(t => t.toLowerCase() === currentTag.toLowerCase());
    }
    if (currentStyle === 'all') return true;
    const s = p.style || detectStyleFromProduct(p);
    return s.toLowerCase() === currentStyle.toLowerCase();
  });

  const typeCounts = {};
  styleProducts.forEach(p => {
    const t = p.hatType || 'Special Editions';
    typeCounts[t] = (typeCounts[t] || 0) + 1;
  });

  const availableTypes = Object.keys(typeCounts);

  let html = `
    <button class="hat-type-pill ${currentHatType === 'all' ? 'active' : ''}" data-hat-type="all">
      <span>All Types</span>
      <span class="type-count">(${styleProducts.length})</span>
    </button>
  `;

  availableTypes.forEach(t => {
    const count = typeCounts[t];
    const isActive = currentHatType.toLowerCase() === t.toLowerCase() ? 'active' : '';
    html += `
      <button class="hat-type-pill ${isActive}" data-hat-type="${escapeHtml(t)}">
        <span>${escapeHtml(t)}</span>
        <span class="type-count">(${count})</span>
      </button>
    `;
  });

  container.innerHTML = html;

  container.querySelectorAll('.hat-type-pill').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const type = e.currentTarget.getAttribute('data-hat-type') || 'all';
      selectHatType(type);
    });
  });
}

function selectHatType(type) {
  currentHatType = type;
  currentPage = 1;

  const container = document.getElementById('hatTypesPillsContainer');
  if (container) {
    container.querySelectorAll('.hat-type-pill').forEach(btn => {
      const t = btn.getAttribute('data-hat-type');
      btn.classList.toggle('active', (t === 'all' && type === 'all') || (t && t.toLowerCase() === type.toLowerCase()));
    });
  }

  applyFilterAndRender();
  scrollToCatalogTop();
}

// ==========================================================================
// DANIEL'S HOMEPAGE: BESTSELLER SAMPLE SHOWCASE & HAT TYPE DROPDOWN SYSTEM
// ==========================================================================
function initSamplerCarousel() {
  const track = document.getElementById('samplerCarouselTrack');
  const viewport = document.getElementById('samplerViewport');
  const prevBtn = document.getElementById('samplerPrevBtn');
  const nextBtn = document.getElementById('samplerNextBtn');
  const dotsContainer = document.getElementById('samplerDots');
  if (!track || !viewport) return;

  // Curate 6 to 8 standout sample hats representing different styles and cuts
  let sampleItems = [];
  const preferredIds = [
    'laroye-001', // Nexus Winged Crown Fitted
    'laroye-002', // Imperial Scepter Crown Snapback
    'laroye-007', // Arc-Tech Luminescent Circuit Snapback
    'laroye-008', // Neo-Chrome Liquid Scepter Fitted
    'laroye-009', // Raw Underground 90s Block Party Fitted
    'laroye-010', // Obsidian Minimal Architectural Cap
    'laroye-011', // The Chrome Scepter Crown Fitted
    'laroye-003'  // Trident Fitted
  ];

  preferredIds.forEach(id => {
    const found = allProducts.find(p => p.id === id);
    if (found && !sampleItems.some(s => s.id === found.id)) sampleItems.push(found);
  });

  // Fallback if needed
  if (sampleItems.length < 6) {
    allProducts.forEach(p => {
      if (!sampleItems.some(s => s.id === p.id) && sampleItems.length < 8) {
        sampleItems.push(p);
      }
    });
  }

  // Render cards
  track.innerHTML = sampleItems.map(p => {
    const safeId = p.id.replace(/'/g, "\\'");
    const style = p.style || detectStyleFromProduct(p) || 'Custom Editions';
    const hatType = p.hatType || 'Crown Edition';
    const badgeText = p.badge || (p.isPresale ? 'Pre-Sale' : (p.oldPrice ? 'Featured Drop' : 'Exclusiva'));
    let badgeClass = '';
    if (badgeText.toLowerCase().includes('pre')) badgeClass = 'badge-presale';
    else if (badgeText.toLowerCase().includes('sold')) badgeClass = 'badge-soldout';

    return `
      <div class="sampler-card" data-id="${escapeHtml(p.id)}">
        <div class="sampler-card-img-wrap" onclick="openProductModal('${safeId}')">
          <img class="sampler-card-img" src="${p.img}" alt="${escapeHtml(p.name)}" loading="lazy">
          <span class="sampler-badge ${badgeClass}">${escapeHtml(badgeText)}</span>
          <img class="sampler-watermark" src="${window.LAROYE_LOGO_URL || 'assets/img/laroye_logo.jpg'}" alt="Laroye Badge">
        </div>
        <div class="sampler-card-body">
          <span class="sampler-card-kicker">${escapeHtml(style)} • ${escapeHtml(hatType)}</span>
          <h3 class="sampler-card-title" onclick="openProductModal('${safeId}')">${escapeHtml(p.name)}</h3>
          <div class="sampler-card-price-row">
            <span class="sampler-price">$${p.price.toFixed(2)}</span>
            ${p.oldPrice ? `<span class="sampler-old-price">$${p.oldPrice.toFixed(2)}</span>` : ''}
          </div>
          <div class="sampler-card-actions">
            <button class="sampler-btn-quickview" onclick="openProductModal('${safeId}')">Quick View</button>
            <button class="sampler-btn-explore" onclick="selectHatTypeOrStyle('style', '${escapeHtml(style)}')">Explore ${escapeHtml(style.split(' ')[0])} &rarr;</button>
          </div>
        </div>
      </div>
    `;
  }).join('');

  // Setup navigation arrows
  if (prevBtn) {
    prevBtn.onclick = () => {
      viewport.scrollBy({ left: -310, behavior: 'smooth' });
    };
  }
  if (nextBtn) {
    nextBtn.onclick = () => {
      viewport.scrollBy({ left: 310, behavior: 'smooth' });
    };
  }

  // Setup indicator dots
  if (dotsContainer) {
    const dotCount = Math.min(sampleItems.length, 6);
    let dotsHtml = '';
    for (let i = 0; i < dotCount; i++) {
      dotsHtml += `<span class="sampler-dot ${i === 0 ? 'active' : ''}" data-index="${i}"></span>`;
    }
    dotsContainer.innerHTML = dotsHtml;

    dotsContainer.querySelectorAll('.sampler-dot').forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        viewport.scrollTo({ left: idx * 310, behavior: 'smooth' });
      });
    });

    viewport.addEventListener('scroll', () => {
      const scrollPos = viewport.scrollLeft;
      const activeIdx = Math.round(scrollPos / 310);
      dotsContainer.querySelectorAll('.sampler-dot').forEach((dot, idx) => {
        dot.classList.toggle('active', idx === activeIdx);
      });
    }, { passive: true });
  }
}

window.selectHatTypeOrStyle = function(categoryKey, value, shouldScroll = true) {
  isSamplerMode = false;

  if (categoryKey === 'style') {
    currentStyle = value;
    currentHatType = 'all';
    currentTag = 'all';
  } else if (categoryKey === 'type') {
    currentStyle = 'all';
    currentHatType = value;
    currentTag = 'all';
  } else if (categoryKey === 'tag') {
    currentStyle = 'all';
    currentHatType = 'all';
    currentTag = value;
  }

  currentPage = 1;

  // Reveal catalog section & collections strip
  const shopSec = document.getElementById('shop-sec');
  const collectionsSec = document.getElementById('collections');
  if (shopSec) shopSec.classList.add('revealed');
  if (collectionsSec) collectionsSec.classList.add('revealed');

  // Update active filter banner
  const filterBanner = document.getElementById('revealedFilterBanner');
  const labelEl = document.getElementById('filterIndicatorLabel');
  if (filterBanner) {
    filterBanner.style.display = 'flex';
  }
  if (labelEl) {
    if (categoryKey === 'style') {
      const disp = value === 'all' ? 'All Official Releases' :
                   value === 'Los Angeles' ? 'Los Angeles (LA)' :
                   value === 'New York' ? 'New York (NY)' :
                   value === 'San Diego' ? 'San Diego (SD)' :
                   value === 'Mexico' ? 'México' :
                   value === 'Texas' ? 'Houston / Texas' : value;
      labelEl.textContent = `Viewing: ${disp}`;
    } else if (categoryKey === 'tag') {
      let disp = value === 'all' ? 'All Tags' : value;
      if (value === 'Bigg Boss modelos varios') disp = 'BIGG BOSS';
      else if (value === 'Exodo modelos') disp = 'Éxodo';
      else if (value === 'Modelo CT') disp = 'Corridos Tumbados (CT)';
      labelEl.textContent = `Viewing Tag: ${disp}`;
    } else {
      labelEl.textContent = `Viewing Series: ${value === 'all' ? 'All Series' : value}`;
    }
  }

  // Synchronize on-page Hub select
  const hubSelect = document.getElementById('hubHatTypeSelect');
  if (hubSelect) {
    hubSelect.value = `${categoryKey}:${value}`;
  }

  // Synchronize style pills
  const brandPillsWrap = document.getElementById('shopifyBrandPills');
  if (brandPillsWrap) {
    brandPillsWrap.querySelectorAll('.brand-pill').forEach(btn => {
      const s = btn.getAttribute('data-style') || btn.getAttribute('data-brand');
      btn.classList.toggle('active', (categoryKey === 'style' && ((s === 'all' && currentStyle === 'all') || (s && s.toLowerCase() === currentStyle.toLowerCase()))) || (categoryKey !== 'style' && s === 'all'));
    });
  }

  // Synchronize tag pills
  const tagPillsWrap = document.getElementById('shopifyTagPills');
  if (tagPillsWrap) {
    tagPillsWrap.querySelectorAll('.tag-pill').forEach(btn => {
      const t = btn.getAttribute('data-tag');
      btn.classList.toggle('active', (categoryKey === 'tag' && ((t === 'all' && currentTag === 'all') || (t && t.toLowerCase() === currentTag.toLowerCase()))) || (categoryKey !== 'tag' && t === 'all'));
    });
  }

  // Synchronize toolbar style select
  const brandSelect = document.getElementById('brandSelect');
  if (brandSelect && categoryKey === 'style') {
    brandSelect.value = value;
  } else if (brandSelect) {
    brandSelect.value = 'all';
  }

  // Update Hat Types sub-filters
  renderHatTypesSubFilter();
  applyFilterAndRender();

  if (shouldScroll) {
    setTimeout(() => {
      const target = document.getElementById('shop-sec');
      if (target) {
        const navHeight = 90;
        const targetPos = target.getBoundingClientRect().top + window.pageYOffset - navHeight;
        window.scrollTo({ top: targetPos, behavior: 'smooth' });
      }
    }, 100);
  }
};

window.resetToSamplerView = function() {
  selectHatTypeOrStyle('style', 'all', true);
};

window.handleNavDropdownClick = function(categoryKey, value, event) {
  if (event) event.preventDefault();
  const dropdown = document.getElementById('navHatTypesDropdown');
  if (dropdown) dropdown.classList.remove('open');
  selectHatTypeOrStyle(categoryKey, value, true);
};

window.onHubHatTypeSelected = function(val) {
  if (!val) return;
  const parts = val.split(':');
  const categoryKey = parts[0];
  const targetVal = parts.slice(1).join(':');
  selectHatTypeOrStyle(categoryKey, targetVal, true);
};

window.handleMobileNavClick = function(categoryKey, value) {
  closeMobileMenu();
  selectHatTypeOrStyle(categoryKey, value, true);
};

window.revealFullCatalog = function(style = 'all', type = 'all') {
  selectHatTypeOrStyle('style', 'all', true);
};

window.hideCatalogToFrontPage = function() {
  const shopSec = document.getElementById('shop-sec');
  if (shopSec) shopSec.classList.remove('revealed');
  const filterBanner = document.getElementById('revealedFilterBanner');
  if (filterBanner) filterBanner.style.display = 'none';
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

window.toggleBrandVideoSound = function() {
  const vid = document.getElementById('laroyeBrandVideo');
  const icon = document.getElementById('videoSoundIcon');
  if (!vid) return;
  vid.muted = !vid.muted;
  if (icon) {
    icon.textContent = vid.muted ? '🔇' : '🔊';
  }
};

function initBrandVideoObserver() {
  const video = document.getElementById('laroyeBrandVideo');
  if (!video) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.25 });

    observer.observe(video);
  }
}

// Pre-sale helper (No cancellation / return policy applies strictly to pre-sale items only)
function isItemPresale(p) {
  if (!p) return false;
  return p.isPresale === true || (p.badge && (p.badge.toLowerCase().includes('pre') || p.badge.toLowerCase().includes('presale')));
}

// ==========================================================================
// FILTERING & RENDERING
// ==========================================================================
function applyFilterAndRender() {
  filteredProducts = allProducts.filter(p => {
    // Style / City filter
    const pStyle = p.style || detectStyleFromProduct(p);
    const matchesStyle = (currentStyle === 'all') || 
      (pStyle && pStyle.toLowerCase() === currentStyle.toLowerCase());

    // Hat Type filter
    const matchesHatType = (currentHatType === 'all') || 
      (p.hatType && p.hatType.toLowerCase() === currentHatType.toLowerCase());

    // Tag filter
    const matchesTag = (currentTag === 'all') || 
      (Array.isArray(p.tags) && p.tags.some(t => t.toLowerCase() === currentTag.toLowerCase()));

    // Search query (checks name, style, brand, hatType, description, and tags)
    const q = searchQuery.toLowerCase();
    const matchesSearch = !q || 
      p.name.toLowerCase().includes(q) || 
      (p.style && p.style.toLowerCase().includes(q)) ||
      (p.brand && p.brand.toLowerCase().includes(q)) || 
      (p.hatType && p.hatType.toLowerCase().includes(q)) ||
      (p.description && p.description.toLowerCase().includes(q)) ||
      (Array.isArray(p.tags) && p.tags.some(t => t.toLowerCase().includes(q)));

    return matchesStyle && matchesHatType && matchesTag && matchesSearch;
  });

  // Sort
  if (currentSort === 'price-asc') {
    filteredProducts.sort((a, b) => a.price - b.price);
  } else if (currentSort === 'price-desc') {
    filteredProducts.sort((a, b) => b.price - a.price);
  } else if (currentSort === 'alpha') {
    filteredProducts.sort((a, b) => a.name.localeCompare(b.name));
  } else if (currentSort === 'stock') {
    filteredProducts.sort((a, b) => (b.inStock ? 1 : 0) - (a.inStock ? 1 : 0));
  }

  const countEl = document.getElementById('catalogCount');
  if (countEl) {
    let label = `Official Releases`;
    if (currentTag !== 'all') {
      let disp = currentTag;
      if (currentTag === 'Bigg Boss modelos varios') disp = 'BIGG BOSS';
      else if (currentTag === 'Exodo modelos') disp = 'Éxodo';
      else if (currentTag === 'Modelo CT') disp = 'Corridos Tumbados (CT)';
      label = `Tag: ${disp}`;
    } else if (currentStyle !== 'all') {
      const disp = currentStyle === 'Los Angeles' ? 'Los Angeles (LA)' :
                   currentStyle === 'New York' ? 'New York (NY)' :
                   currentStyle === 'San Diego' ? 'San Diego (SD)' :
                   currentStyle === 'Mexico' ? 'México' :
                   currentStyle === 'Texas' ? 'Houston / Texas' : currentStyle;
      label = `Collection: ${disp}`;
    }
    if (currentHatType !== 'all') {
      label += ` • ${currentHatType}`;
    }
    countEl.textContent = label;
  }

  renderProductGrid();
  renderPagination();
}

function renderProductGrid() {
  const grid = document.getElementById('productGrid');
  if (!grid) return;

  if (filteredProducts.length === 0) {
    const isCity = ['los angeles', 'new york', 'san diego', 'chicago', 'texas'].includes(currentStyle.toLowerCase());
    grid.innerHTML = `
      <div class="empty-catalog">
        <h3>${isCity ? `${currentStyle} Drops Coming Soon` : 'No Caps Found in Vault'}</h3>
        <p>${isCity ? `Daniel and the Laroye Hats team are uploading new ${currentStyle} crowns. Contact our direct VIP WhatsApp for pre-orders or custom sizing.` : 'Try resetting your search or viewing all releases.'}</p>
        <div style="display: flex; gap: 12px; justify-content: center; margin-top: 14px; flex-wrap: wrap;">
          <button class="btn-secondary" onclick="resetFilters()">View All Drops</button>
          ${isCity ? `<a href="https://wa.me/19729037510" target="_blank" rel="noopener" class="btn-primary" style="text-decoration: none; padding: 10px 20px; font-size: 13px;">💬 WhatsApp VIP Inquiry</a>` : ''}
        </div>
      </div>
    `;
    return;
  }

  const startIdx = (currentPage - 1) * CONFIG.itemsPerPage;
  const pageItems = filteredProducts.slice(startIdx, startIdx + CONFIG.itemsPerPage);

  const isCyber = document.body.classList.contains('theme-monolith');
  const isNeoChrome = document.body.classList.contains('theme-neochrome') || document.body.classList.contains('theme-atelier');
  const isVintage = document.body.classList.contains('theme-vintage');
  const isMinimal = document.body.classList.contains('theme-minimal');

  if (isCyber) {
    grid.className = 'product-grid cyber-matrix-grid';
    grid.innerHTML = pageItems.map((p, idx) => renderCyberCard(p, idx)).join('');
  } else if (isNeoChrome) {
    grid.className = 'product-grid neochrome-bento-grid';
    grid.innerHTML = pageItems.map((p, idx) => renderNeoChromeCard(p, idx)).join('');
  } else if (isVintage) {
    grid.className = 'product-grid vintage-crate-grid';
    grid.innerHTML = pageItems.map((p, idx) => renderVintageCard(p, idx)).join('');
  } else if (isMinimal) {
    const viewMode = window.minimalViewMode || 'grid';
    grid.className = viewMode === 'list' ? 'product-grid minimal-list-grid' : 'product-grid minimal-pedestal-grid';
    grid.innerHTML = pageItems.map((p, idx) => renderMinimalCard(p, idx)).join('');
  } else {
    // Template 1: The Vault Classic Street Luxury Grid
    grid.className = 'product-grid vault-classic-grid';
    grid.innerHTML = pageItems.map(p => renderVaultCard(p)).join('');
  }
}

// ==========================================================================
// TEMPLATE 1: THE VAULT CLASSIC CARD
// ==========================================================================
function renderVaultCard(p) {
  const isSoldOut = !p.inStock;
  let badgeClass = 'badge-red';
  if (p.badge) {
    const bLower = p.badge.toLowerCase();
    if (bLower.includes('sold')) badgeClass = 'badge-soldout';
    else if (bLower.includes('sale')) badgeClass = 'badge-gold';
    else if (bLower.includes('pre')) badgeClass = 'badge-silver';
  }

  const badgeHtml = p.badge ? `<div class="card-badge badge-tag ${badgeClass}">${p.badge}</div>` : '';
  const scarcityHtml = (!isSoldOut && p.scarcityText) ? `<div class="card-scarcity">${p.scarcityText}</div>` : '';
  const oldPriceHtml = p.oldPrice ? `<span class="card-old-price">$${p.oldPrice.toFixed(2)}</span>` : '';
  const safeId = p.id.replace(/'/g, "\\'");

  return `
    <div class="product-card vault-card" onclick="openProductModal('${safeId}')">
      <div class="card-img-wrap">
        <img class="product-img" src="${p.img}" alt="${escapeHtml(p.name)}" loading="lazy">
        ${badgeHtml}
        ${scarcityHtml}
        <img class="card-watermark" src="${window.LAROYE_LOGO_URL || 'assets/img/laroye_logo.jpg'}" alt="Laroye Badge">
      </div>
      <div class="card-content">
        <div class="card-brand">${escapeHtml(p.brand)}</div>
        <h3 class="card-title">${escapeHtml(p.name)}</h3>
        <div class="card-price-row">
          <span class="card-price">$${p.price.toFixed(2)}</span>
          ${oldPriceHtml}
        </div>
        ${isSoldOut ? 
          `<button class="card-action-btn sold-out" disabled>Sold Out</button>` : 
          `<button class="card-action-btn" onclick="event.stopPropagation(); quickAddToCart('${safeId}')">Add to Cart</button>`
        }
      </div>
    </div>
  `;
}

// ==========================================================================
// TEMPLATE 2: CYBER EMBLEM MATRIX WITH ASYMMETRIC SPOTLIGHT FEATURE
// ==========================================================================
function renderCyberCard(p, index) {
  const isSoldOut = !p.inStock;
  const safeId = p.id.replace(/'/g, "\\'");
  const oldPriceHtml = p.oldPrice ? `<span class="cyber-old-price">$${p.oldPrice.toFixed(2)}</span>` : '';
  const badgeHtml = p.badge ? `<span class="cyber-badge-tag">${escapeHtml(p.badge)}</span>` : '';

  // First item is a prominent 2-column feature showcase card!
  if (index === 0) {
    const sizeChips = p.sizes.map(s => 
      `<button class="cyber-chip" onclick="event.stopPropagation(); quickAddToCart('${safeId}', '${escapeHtml(s)}')">${escapeHtml(s)}</button>`
    ).slice(0, 4).join('');

    return `
      <div class="cyber-feature-card" onclick="openProductModal('${safeId}')">
        <div class="cyber-feature-hud-top">
          <span class="cyber-hud-label"><span class="cyber-pulse-dot"></span> [EMBLEM SPOTLIGHT // LRY-${p.id.slice(-3)}]</span>
          <span class="cyber-hud-spec">SERIES: ${escapeHtml(p.collection).toUpperCase()}</span>
        </div>
        <div class="cyber-feature-body">
          <div class="cyber-feature-visual">
            <img src="${p.img}" alt="${escapeHtml(p.name)}" class="cyber-feature-img" loading="lazy">
            <div class="cyber-scanlines"></div>
            ${badgeHtml}
          </div>
          <div class="cyber-feature-info">
            <div class="cyber-meta-code">// BRAND: ${escapeHtml(p.brand).toUpperCase()}</div>
            <h3 class="cyber-feature-title">${escapeHtml(p.name)}</h3>
            <p class="cyber-feature-desc">${escapeHtml(p.description)}</p>
            <div class="cyber-price-bar">
              <span class="cyber-main-price">$${p.price.toFixed(2)}</span>
              ${oldPriceHtml}
              <span class="cyber-stock-indicator ${isSoldOut ? 'out' : 'in'}">${isSoldOut ? '[DEPLETED]' : '[IN VAULT]'}</span>
            </div>
            ${!isSoldOut ? `
              <div class="cyber-quick-sizes">
                <span class="cyber-sizes-label">Instant Size Select:</span>
                <div class="cyber-chips-wrap">${sizeChips}</div>
              </div>
            ` : ''}
            <div class="cyber-actions-row">
              ${isSoldOut ? 
                `<button class="cyber-btn sold-out" disabled>[SYSTEM DEPLETED]</button>` :
                `<button class="cyber-btn" onclick="event.stopPropagation(); quickAddToCart('${safeId}')">[INITIALIZE ACQUISITION]</button>`
              }
              <button class="cyber-btn-ghost" onclick="event.stopPropagation(); openProductModal('${safeId}')">EXPAND DATA ↗</button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // Standard 3-column cyber matrix cards
  return `
    <div class="cyber-hud-card" onclick="openProductModal('${safeId}')">
      <div class="cyber-card-header">
        <span class="cyber-serial">#LRY-${p.id.slice(-3)}</span>
        <span class="cyber-brand-chip">${escapeHtml(p.brand)}</span>
      </div>
      <div class="cyber-img-container">
        <img src="${p.img}" alt="${escapeHtml(p.name)}" class="cyber-card-img" loading="lazy">
        <div class="cyber-corner-reticle top-l"></div>
        <div class="cyber-corner-reticle bottom-r"></div>
        ${badgeHtml}
      </div>
      <div class="cyber-card-details">
        <h4 class="cyber-card-title">${escapeHtml(p.name)}</h4>
        <div class="cyber-card-footer">
          <div class="cyber-price-group">
            <span class="cyber-price">$${p.price.toFixed(2)}</span>
            ${oldPriceHtml}
          </div>
          ${isSoldOut ?
            `<button class="cyber-card-btn sold-out" disabled>DEPLETED</button>` :
            `<button class="cyber-card-btn" onclick="event.stopPropagation(); quickAddToCart('${safeId}')">ACQUIRE</button>`
          }
        </div>
      </div>
    </div>
  `;
}

// ==========================================================================
// TEMPLATE 3: MODERN LUXURY STREETWEAR E-COMMERCE CARDS
// ==========================================================================
function renderNeoChromeCard(p, index) {
  const isSoldOut = !p.inStock;
  const safeId = p.id.replace(/'/g, "\\'");
  const oldPriceHtml = p.oldPrice ? `<span class="ecom-old-price">$${p.oldPrice.toFixed(2)}</span>` : '';
  const badgeHtml = p.badge ? `<span class="ecom-badge">${escapeHtml(p.badge)}</span>` : '';
  const isFeature = index === 0;

  const sizeChips = p.sizes.map(s => 
    `<button class="ecom-size-chip" onclick="event.stopPropagation(); quickAddToCart('${safeId}', '${escapeHtml(s)}')">${escapeHtml(s)}</button>`
  ).slice(0, 4).join('');

  if (isFeature) {
    return `
      <div class="ecom-hero-card" onclick="openProductModal('${safeId}')">
        <div class="ecom-hero-img-box">
          <img src="${p.img}" alt="${escapeHtml(p.name)}" class="ecom-hero-img" loading="lazy">
          ${badgeHtml}
          <div class="ecom-quick-view-badge">Quick View</div>
        </div>
        <div class="ecom-hero-content">
          <div class="ecom-card-brand">${escapeHtml(p.brand).toUpperCase()}</div>
          <h3 class="ecom-hero-title">${escapeHtml(p.name)}</h3>
          <div class="ecom-rating-row">
            <span class="ecom-stars">★★★★★</span>
            <span class="ecom-rating-text">4.9 (142 reviews)</span>
          </div>
          <p class="ecom-hero-desc">${escapeHtml(p.description)}</p>
          <div class="ecom-price-row">
            <span class="ecom-price-main">$${p.price.toFixed(2)}</span>
            ${oldPriceHtml}
            <span class="ecom-stock-tag ${isSoldOut ? 'sold-out' : 'in-stock'}">
              ${isSoldOut ? 'Out of Stock' : '✓ In Stock — Ships Today'}
            </span>
          </div>
          ${!isSoldOut ? `
            <div class="ecom-size-wrap">
              <span class="ecom-size-label">Select Size:</span>
              <div class="ecom-sizes-flex">${sizeChips}</div>
            </div>
          ` : ''}
          <div class="ecom-btn-row">
            ${isSoldOut ?
              `<button class="ecom-add-btn sold-out" disabled>OUT OF STOCK</button>` :
              `<button class="ecom-add-btn" onclick="event.stopPropagation(); quickAddToCart('${safeId}')">ADD TO CART &bull; $${p.price.toFixed(2)}</button>`
            }
          </div>
        </div>
      </div>
    `;
  }

  // Standard 3-column Modern E-Commerce Card
  return `
    <div class="ecom-card" onclick="openProductModal('${safeId}')">
      <div class="ecom-card-img-wrap">
        <img src="${p.img}" alt="${escapeHtml(p.name)}" class="ecom-card-img" loading="lazy">
        ${badgeHtml}
        <button class="ecom-quick-view-btn" onclick="event.stopPropagation(); openProductModal('${safeId}')">Quick View</button>
      </div>
      <div class="ecom-card-body">
        <div class="ecom-card-brand">${escapeHtml(p.brand).toUpperCase()}</div>
        <h4 class="ecom-card-title">${escapeHtml(p.name)}</h4>
        <div class="ecom-rating-row">
          <span class="ecom-stars">★★★★★</span>
          <span class="ecom-rating-text">4.9</span>
        </div>
        <div class="ecom-card-foot">
          <div class="ecom-price-box">
            <span class="ecom-price">$${p.price.toFixed(2)}</span>
            ${oldPriceHtml}
          </div>
          ${isSoldOut ?
            `<button class="ecom-card-add-btn sold-out" disabled>SOLD OUT</button>` :
            `<button class="ecom-card-add-btn" onclick="event.stopPropagation(); quickAddToCart('${safeId}')">${isItemPresale(p) ? 'PRE-ORDER' : 'ADD TO CART'}</button>`
          }
        </div>
        ${isItemPresale(p) ? `<div class="ecom-presale-warning">⚠️ Pre-Sale &bull; No Cancellations / Returns</div>` : ''}
      </div>
    </div>
  `;
}

// ==========================================================================
// TEMPLATE 4: RAW 90s VINTAGE POLAROID CRATE COLLAGE
// ==========================================================================
const TAPE_ANGLES = ["tape-tilt-left", "tape-tilt-right", "tape-center"];
const CARD_ROTATES = ["rot-left", "rot-right", "rot-straight", "rot-slight-left"];

function renderVintageCard(p, index) {
  const isSoldOut = !p.inStock;
  const safeId = p.id.replace(/'/g, "\\'");
  const tapeClass = TAPE_ANGLES[index % TAPE_ANGLES.length];
  const rotClass = CARD_ROTATES[index % CARD_ROTATES.length];
  const oldPriceHtml = p.oldPrice ? `<span class="vintage-old-price">$${p.oldPrice.toFixed(2)}</span>` : '';
  const tapeText = ["DEADSTOCK", "AUTHENTIC '90S", "RECORD CRATE", "RARE PRESSING"][index % 4];

  return `
    <div class="vintage-polaroid-card ${rotClass}" onclick="openProductModal('${safeId}')">
      <div class="vintage-masking-tape ${tapeClass}">
        <span>${tapeText}</span>
      </div>
      <div class="polaroid-inner-frame">
        <div class="polaroid-photo-box">
          <img src="${p.img}" alt="${escapeHtml(p.name)}" class="polaroid-img" loading="lazy">
          <div class="vintage-price-tag">
            <span class="price-sticker">$${p.price.toFixed(2)}</span>
          </div>
          ${p.badge ? `<div class="vintage-neon-sticker">${escapeHtml(p.badge)}</div>` : ''}
        </div>
        <div class="polaroid-chin">
          <div class="polaroid-brand-stamp">${escapeHtml(p.brand).toUpperCase()}</div>
          <h3 class="polaroid-handwritten-title">${escapeHtml(p.name)}</h3>
          <div class="polaroid-audio-track">
            <span>SIDE A // TRACK 0${(index % 9) + 1}</span>
            ${oldPriceHtml}
          </div>
          <div class="vintage-card-actions">
            ${isSoldOut ?
              `<button class="vintage-cop-btn sold-out" disabled>SOLD OUT</button>` :
              `<button class="vintage-cop-btn" onclick="event.stopPropagation(); quickAddToCart('${safeId}')">COP THIS CAP</button>`
            }
          </div>
        </div>
      </div>
    </div>
  `;
}

// ==========================================================================
// TEMPLATE 5: OBSIDIAN MINIMAL PEDESTAL & ARCHITECTURAL LIST VIEW
// ==========================================================================
function renderMinimalCard(p, index) {
  const isSoldOut = !p.inStock;
  const safeId = p.id.replace(/'/g, "\\'");
  const itemNum = String(index + 1).padStart(2, '0');
  const viewMode = window.minimalViewMode || 'grid';

  if (viewMode === 'list') {
    return `
      <div class="minimal-list-row" onclick="openProductModal('${safeId}')">
        <span class="minimal-list-index">${itemNum}</span>
        <div class="minimal-list-thumb-box">
          <img src="${p.img}" alt="${escapeHtml(p.name)}" class="minimal-list-thumb" loading="lazy">
        </div>
        <div class="minimal-list-info">
          <h4 class="minimal-list-title">${escapeHtml(p.name)}</h4>
          <span class="minimal-list-brand">${escapeHtml(p.brand)} &bull; ${escapeHtml(p.collection)}</span>
        </div>
        <div class="minimal-list-pricing">
          <span class="minimal-list-price">$${p.price.toFixed(2)}</span>
          ${p.oldPrice ? `<span class="minimal-list-old">$${p.oldPrice.toFixed(2)}</span>` : ''}
        </div>
        <div class="minimal-list-action">
          ${isSoldOut ? 
            `<span class="minimal-pill-depleted">Sold Out</span>` :
            `<button class="minimal-pill-add" onclick="event.stopPropagation(); quickAddToCart('${safeId}')">Add to Bag</button>`
          }
        </div>
      </div>
    `;
  }

  // Spacious 2-column museum pedestal cards
  return `
    <div class="minimal-pedestal-card" onclick="openProductModal('${safeId}')">
      <div class="pedestal-card-top">
        <span class="pedestal-index">${itemNum} &mdash; ${escapeHtml(p.brand)}</span>
        ${p.badge ? `<span class="pedestal-whisper-badge">${escapeHtml(p.badge)}</span>` : ''}
      </div>
      <div class="pedestal-stage">
        <img src="${p.img}" alt="${escapeHtml(p.name)}" class="pedestal-img" loading="lazy">
        <div class="pedestal-shadow-radial"></div>
      </div>
      <div class="pedestal-caption">
        <div class="pedestal-title-row">
          <h3 class="pedestal-name">${escapeHtml(p.name)}</h3>
          <span class="pedestal-price">$${p.price.toFixed(2)}</span>
        </div>
        <p class="pedestal-subline">${p.sizes.slice(0, 3).join(' &bull; ')}</p>
        <div class="pedestal-hover-drawer">
          ${isSoldOut ? 
            `<span class="pedestal-btn sold-out">Currently Unavailable</span>` :
            `<button class="pedestal-btn" onclick="event.stopPropagation(); quickAddToCart('${safeId}')">Add to Bag &mdash; $${p.price.toFixed(2)}</button>`
          }
        </div>
      </div>
    </div>
  `;
}

// Minimal view mode switcher
window.setMinimalView = function(mode) {
  window.minimalViewMode = mode;
  document.querySelectorAll('.view-toggle-btn').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.mode === mode);
  });
  renderProductGrid();
};
window.renderProducts = renderProductGrid;

// ==========================================================================
// PAGINATION WITH COORDINATE OFFSET SCROLL
// ==========================================================================
function renderPagination() {
  const container = document.getElementById('paginationContainer');
  if (!container) return;

  const totalPages = Math.ceil(filteredProducts.length / CONFIG.itemsPerPage);
  if (totalPages <= 1) {
    container.innerHTML = '';
    return;
  }

  let html = `
    <button class="page-btn" onclick="changePage(-1)" ${currentPage === 1 ? 'disabled' : ''}>&larr;</button>
  `;

  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      html += `
        <button class="page-btn ${i === currentPage ? 'active' : ''}" onclick="goToPage(${i})">${i}</button>
      `;
    }
  } else {
    const pages = [1];
    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    if (currentPage <= 3) {
      start = 2;
      end = 4;
    } else if (currentPage >= totalPages - 2) {
      start = totalPages - 3;
      end = totalPages - 1;
    }

    if (start > 2) pages.push('...');
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    if (end < totalPages - 1) pages.push('...');
    pages.push(totalPages);

    pages.forEach(p => {
      if (p === '...') {
        html += `<span class="page-ellipsis" style="color:var(--text-muted);padding:8px 4px;font-family:var(--font-mono);font-size:12px;">...</span>`;
      } else {
        html += `<button class="page-btn ${p === currentPage ? 'active' : ''}" onclick="goToPage(${p})">${p}</button>`;
      }
    });
  }

  html += `
    <button class="page-btn" onclick="changePage(1)" ${currentPage === totalPages ? 'disabled' : ''}>&rarr;</button>
  `;

  container.innerHTML = html;
}

function changePage(delta) {
  currentPage += delta;
  renderProductGrid();
  renderPagination();
  scrollToCatalogTop();
}

function goToPage(page) {
  currentPage = page;
  renderProductGrid();
  renderPagination();
  scrollToCatalogTop();
}

function scrollToCatalogTop() {
  const el = document.getElementById('shop-sec');
  if (el) {
    el.classList.add('revealed');
    setTimeout(() => {
      const headerOffset = 90;
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }, 50);
  }
}

// ==========================================================================
// NIKE-GRADE PRODUCT DETAIL EXPERIENCE (PDP)
// ==========================================================================
let currentReviewRating = 5;
let cartDiscountPct = 0;
let appliedPromoCode = '';

function openProductModal(productId) {
  selectedProduct = allProducts.find(p => p.id === productId || p.handle === productId);
  if (!selectedProduct) return;

  selectedSize = selectedProduct.sizes[0] || 'One Size';

  // Gallery & Image
  const mainImg = document.getElementById('modalMainImg');
  if (mainImg) {
    mainImg.src = selectedProduct.img;
    mainImg.alt = selectedProduct.name;
  }

  // Breadcrumbs & Brand Kickers
  const brandEl = document.getElementById('modalBrand');
  if (brandEl) brandEl.textContent = selectedProduct.brand;
  const breadcrumbBrand = document.getElementById('pdpBreadcrumbBrand');
  if (breadcrumbBrand) breadcrumbBrand.textContent = selectedProduct.brand.toUpperCase();

  // Title
  const titleEl = document.getElementById('modalTitle');
  if (titleEl) titleEl.textContent = selectedProduct.name;
  const breadcrumbTitle = document.getElementById('pdpBreadcrumbTitle');
  if (breadcrumbTitle) breadcrumbTitle.textContent = selectedProduct.name.toUpperCase();

  // Price & Savings
  const priceEl = document.getElementById('modalPrice');
  if (priceEl) priceEl.textContent = `$${selectedProduct.price.toFixed(2)}`;
  const btnPrice = document.getElementById('modalBtnPrice');
  if (btnPrice) btnPrice.textContent = `$${selectedProduct.price.toFixed(2)}`;

  const oldPriceEl = document.getElementById('modalOldPrice');
  const saveBadge = document.getElementById('modalSaveBadge');
  if (selectedProduct.oldPrice && selectedProduct.oldPrice > selectedProduct.price) {
    if (oldPriceEl) {
      oldPriceEl.textContent = `$${selectedProduct.oldPrice.toFixed(2)}`;
      oldPriceEl.style.display = 'inline';
    }
    if (saveBadge) {
      const saved = selectedProduct.oldPrice - selectedProduct.price;
      saveBadge.textContent = `SAVE $${saved.toFixed(2)}`;
      saveBadge.style.display = 'inline-block';
    }
  } else {
    if (oldPriceEl) oldPriceEl.style.display = 'none';
    if (saveBadge) saveBadge.style.display = 'none';
  }

  // Installments (4 interest-free payments)
  const installmentEl = document.getElementById('modalInstallmentPrice');
  if (installmentEl) {
    const quad = (selectedProduct.price / 4).toFixed(2);
    installmentEl.textContent = `$${quad}`;
  }

  // Badge State
  const badgeEl = document.getElementById('modalBadge');
  if (badgeEl) {
    if (!selectedProduct.inStock) {
      badgeEl.textContent = 'SOLD OUT';
      badgeEl.className = 'pdp-badge soldout';
    } else if (isItemPresale(selectedProduct)) {
      badgeEl.textContent = 'PRE-SALE RELEASE';
      badgeEl.className = 'pdp-badge presale';
    } else {
      badgeEl.textContent = 'EXCLUSIVE DROP';
      badgeEl.className = 'pdp-badge';
    }
  }

  // Dispatch Urgency Countdown
  updateDispatchCountdown();

  // Description
  const fallbackDesc = window.ShopifyClient && window.ShopifyClient.generateRichDescription
    ? window.ShopifyClient.generateRichDescription(selectedProduct.name, selectedProduct.brand, selectedProduct.hatType, isItemPresale(selectedProduct))
    : 'Authentic custom headwear piece. Handcrafted structured silhouette with ultra-dense dimensional embroidery, reinforced crown panels, and premium inner lining. Born to be different.';

  const descEl = document.getElementById('modalDesc');
  if (descEl) {
    descEl.textContent = (selectedProduct.description && selectedProduct.description.trim().length > 0)
      ? selectedProduct.description
      : fallbackDesc;
  }

  // Tags Display in PDP
  const tagsWrap = document.getElementById('modalTagsWrap');
  if (tagsWrap) {
    if (selectedProduct.tags && selectedProduct.tags.length > 0) {
      tagsWrap.style.display = 'flex';
      tagsWrap.innerHTML = selectedProduct.tags.map(t => {
        const cleanT = (t || '').trim();
        return `<span class="pdp-tag-chip" onclick="closeProductModal(); selectTag('${escapeHtml(cleanT)}');" style="cursor:pointer;" title="Filter by tag: ${escapeHtml(cleanT)}">🏷️ ${escapeHtml(cleanT)}</span>`;
      }).join('');
    } else {
      tagsWrap.style.display = 'none';
      tagsWrap.innerHTML = '';
    }
  }

  // Thumbnails
  const thumbWrap = document.getElementById('modalThumbs');
  if (thumbWrap) {
    if (selectedProduct.images && selectedProduct.images.length > 1) {
      thumbWrap.style.display = 'flex';
      thumbWrap.innerHTML = selectedProduct.images.map((src, i) => `
        <img src="${src}" class="modal-thumb ${i === 0 ? 'active' : ''}" onclick="switchModalImage(this, '${src}')" alt="Angle ${i+1}">
      `).join('');
    } else {
      thumbWrap.style.display = 'none';
    }
  }

  // Sizes List
  const sizeList = document.getElementById('modalSizesList');
  if (sizeList) {
    sizeList.innerHTML = selectedProduct.sizes.map((sz, i) => `
      <button class="size-pill ${i === 0 ? 'active' : ''}" onclick="selectModalSize(this, '${sz}')">${sz}</button>
    `).join('');
  }

  // Main Add to Bag Button State
  const addBtn = document.getElementById('modalAddBtn');
  if (addBtn) {
    if (!selectedProduct.inStock) {
      addBtn.textContent = 'SOLD OUT';
      addBtn.disabled = true;
      addBtn.style.opacity = '0.4';
    } else if (isItemPresale(selectedProduct)) {
      addBtn.innerHTML = `PRE-ORDER NOW (FINAL SALE) &bull; <span>$${selectedProduct.price.toFixed(2)}</span>`;
      addBtn.disabled = false;
      addBtn.style.opacity = '1';
    } else {
      addBtn.innerHTML = `ADD TO BAG &bull; <span>$${selectedProduct.price.toFixed(2)}</span>`;
      addBtn.disabled = false;
      addBtn.style.opacity = '1';
    }
  }

  // Pre-Sale vs Standard Policy Notice Box in Buy Box
  const policyBox = document.getElementById('modalPolicyBox');
  if (policyBox) {
    if (isItemPresale(selectedProduct)) {
      policyBox.className = 'pdp-policy-notice-box presale-alert';
      policyBox.innerHTML = `
        <div class="policy-notice-head">
          <span class="policy-icon">⚠️</span>
          <strong>PRE-SALE ITEM POLICY (FINAL SALE)</strong>
        </div>
        <p class="policy-notice-body">
          This crown is a custom-manufactured pre-sale release. <u>Strictly NO cancellations, returns, or refunds</u> once placed. All sales are final.
        </p>
      `;
    } else {
      policyBox.className = 'pdp-policy-notice-box standard-alert';
      policyBox.innerHTML = `
        <div class="policy-notice-head">
          <span class="policy-icon">🔒</span>
          <strong>ALL SALES FINAL (EXCLUSIVE RELEASE)</strong>
        </div>
        <p class="policy-notice-body">
          Limited edition designer crown. All sales are final. Verified for 100% authentic craftsmanship prior to boxed dispatch.
        </p>
      `;
    }
  }

  // Accordion Policy Callout Sync
  const accPolicyCallout = document.getElementById('pdpAccPolicyCallout');
  if (accPolicyCallout) {
    if (isItemPresale(selectedProduct)) {
      accPolicyCallout.className = 'acc-policy-callout presale';
      accPolicyCallout.innerHTML = `
        <strong>⚠️ PRE-SALE ITEM POLICY:</strong> All items marked Pre-Sale or Pre-Venta are custom produced on-demand. <u>Strictly NO cancellations, returns, or refunds</u> once placed. All sales are final.
      `;
    } else {
      accPolicyCallout.className = 'acc-policy-callout in-stock';
      accPolicyCallout.innerHTML = `
        <strong>🔒 ALL SALES FINAL:</strong> Due to the exclusive, limited-batch nature of Laroye Hats releases, all sales are strictly final. We do not accept returns, cancellations, or exchanges. Transit damages are replaced immediately upon photo verification within 48 hours.
      `;
    }
  }

  // Populate Mobile Sticky Bar
  const stickyThumb = document.getElementById('stickyThumb');
  if (stickyThumb) stickyThumb.src = selectedProduct.img;
  const stickyTitle = document.getElementById('stickyTitle');
  if (stickyTitle) stickyTitle.textContent = selectedProduct.name;
  const stickyPrice = document.getElementById('stickyPrice');
  if (stickyPrice) stickyPrice.textContent = `$${selectedProduct.price.toFixed(2)}`;
  const stickyAddBtn = document.getElementById('stickyAddBtn');
  if (stickyAddBtn) {
    stickyAddBtn.textContent = !selectedProduct.inStock
      ? 'SOLD OUT'
      : isItemPresale(selectedProduct)
        ? 'PRE-ORDER'
        : 'ADD TO BAG';
    stickyAddBtn.disabled = !selectedProduct.inStock;
  }

  // Render "You Might Also Like"
  renderRelatedProducts(selectedProduct);

  // Render Customer Reviews & Rating
  renderProductReviews(selectedProduct);

  // Open Modal & Reset Scroll
  const modalEl = document.getElementById('productModal');
  if (modalEl) modalEl.classList.add('open');

  const scrollBody = document.getElementById('pdpScrollBody');
  if (scrollBody) scrollBody.scrollTop = 0;

  document.body.style.overflow = 'hidden';

  // Sync URL hash
  try {
    history.replaceState(null, null, `#product-${encodeURIComponent(selectedProduct.id)}`);
  } catch (e) {}
}

function switchModalImage(el, src) {
  const mainImg = document.getElementById('modalMainImg');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.modal-thumb').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
}

function selectModalSize(el, size) {
  selectedSize = size;
  document.querySelectorAll('.size-pill').forEach(s => s.classList.remove('active'));
  el.classList.add('active');
}

function closeProductModal() {
  const modal = document.getElementById('productModal');
  if (modal) modal.classList.remove('open');

  const stickyBar = document.getElementById('pdpStickyBar');
  if (stickyBar) stickyBar.classList.remove('visible');

  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';

  // Clean URL hash if it was a product link
  if (window.location.hash.startsWith('#product-')) {
    try {
      history.replaceState(null, null, window.location.pathname + window.location.search);
    } catch (e) {}
  }
}

// Nike-Style Expandable Accordions
function togglePdpAccordion(btn) {
  const item = btn.closest('.pdp-accordion-item');
  if (!item) return;
  const isOpen = item.classList.contains('open');
  item.classList.toggle('open');
  const chevron = item.querySelector('.acc-chevron');
  if (chevron) {
    chevron.innerHTML = isOpen ? '+' : '&minus;';
  }
}

function openSizeGuideAccordion() {
  const sizingItem = document.getElementById('pdpAccSizing');
  if (sizingItem) {
    sizingItem.classList.add('open');
    const chevron = sizingItem.querySelector('.acc-chevron');
    if (chevron) chevron.innerHTML = '&minus;';
    sizingItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function scrollToPdpSection(id) {
  const target = document.getElementById(id);
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function shareCurrentProduct() {
  if (!selectedProduct) return;
  const shareUrl = window.location.origin + window.location.pathname + '#product-' + encodeURIComponent(selectedProduct.id);
  const shareData = {
    title: `${selectedProduct.name} | Laroye Hats`,
    text: `Check out the ${selectedProduct.name} on Laroye Hats!`,
    url: shareUrl
  };

  if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
    navigator.share(shareData).catch(() => {});
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(shareUrl).then(() => {
      showToast('Product link copied to clipboard!');
    }).catch(() => {
      showToast('Product link ready in browser address bar');
    });
  } else {
    showToast('Product link ready in browser address bar');
  }
}

function updateDispatchCountdown() {
  const el = document.getElementById('pdpDispatchCountdown');
  if (!el) return;

  const now = new Date();
  const target = new Date();
  target.setHours(16, 0, 0, 0); // 4:00 PM cutoff
  if (now > target) {
    target.setDate(target.getDate() + 1);
  }
  const diffMs = target - now;
  const hrs = Math.floor(diffMs / (1000 * 60 * 60));
  const mins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  el.innerHTML = `Order within <strong>${hrs} hrs ${mins} mins</strong> for same-day dispatch`;
}

// "You Might Also Like" Related Products Generator
function renderRelatedProducts(currentProduct) {
  const grid = document.getElementById('pdpRelatedGrid');
  if (!grid) return;

  let related = allProducts.filter(p => p.id !== currentProduct.id && p.brand === currentProduct.brand);
  if (related.length < 4) {
    const others = allProducts.filter(p => p.id !== currentProduct.id && p.brand !== currentProduct.brand);
    related = related.concat(others);
  }
  const picks = related.slice(0, 4);

  grid.innerHTML = picks.map(p => {
    const safeId = p.id.replace(/'/g, "\\'");
    const isPresale = isItemPresale(p);
    const installment = (p.price / 4).toFixed(2);
    return `
      <div class="related-card" onclick="openProductModal('${safeId}')">
        <div class="related-card-img-wrap">
          <img src="${p.img}" alt="${escapeHtml(p.name)}" loading="lazy">
          ${isPresale 
            ? `<span class="related-card-badge presale">PRE-SALE</span>` 
            : `<span class="related-card-badge">${escapeHtml(p.brand)}</span>`}
        </div>
        <div class="related-card-content">
          <div class="related-card-brand">${escapeHtml(p.brand)}</div>
          <h4 class="related-card-title" title="${escapeHtml(p.name)}">${escapeHtml(p.name)}</h4>
          <div class="related-card-price-row">
            <span class="related-card-price">$${p.price.toFixed(2)}</span>
            ${p.oldPrice && p.oldPrice > p.price ? `<span class="related-card-old-price">$${p.oldPrice.toFixed(2)}</span>` : ''}
            <span class="related-card-split">4x $${installment}</span>
          </div>
          <button class="related-card-action-btn" onclick="event.stopPropagation(); quickAddToCart('${safeId}');" aria-label="Add ${escapeHtml(p.name)} to bag">
            <span>+ ADD TO BAG</span>
          </button>
        </div>
      </div>
    `;
  }).join('');
}

// Customer Reviews & Review Submission
function getCuratedDefaultReviews(product) {
  const brandName = product.brand || 'Laroye Hats';
  return [
    {
      author: 'Marcus Vance (Dallas, TX)',
      verified: true,
      rating: 5,
      date: '3 days ago',
      title: 'Crown structure is next level — holds shape flawlessly',
      body: `Hands down the most structured cap in my collection. The high-profile A-frame doesn't sag at all, and the 3D bullion embroidery on the ${product.name} is immaculate. Arrived in a heavy crush-proof box with custom tissue paper. 10/10.`
    },
    {
      author: 'Esteban R. (Chicago, IL)',
      verified: true,
      rating: 5,
      date: '1 week ago',
      title: 'Unbelievable attention to detail and stitching',
      body: `Been buying caps for 15 years, and ${brandName} really sets a standard. The inner moisture-wicking sweatband makes it comfortable to wear all day without forehead pressure. The contrast underbill and crown details are sharp.`
    },
    {
      author: 'David K. (Miami, FL)',
      verified: true,
      rating: 5,
      date: '2 weeks ago',
      title: 'Boxed packaging & fast delivery exceeded expectations',
      body: 'I was worried about ordering high-end headwear online because hats usually get crushed in transit. Laroye shipped this in a reinforced collector box. Pristine condition when opened.'
    }
  ];
}

function renderProductReviews(product) {
  const container = document.getElementById('pdpReviewsList');
  if (!container) return;

  let userReviews = [];
  try {
    const raw = localStorage.getItem('laroye_reviews_' + product.id);
    if (raw) userReviews = JSON.parse(raw);
  } catch (e) {
    userReviews = [];
  }

  const allList = [...userReviews, ...getCuratedDefaultReviews(product)];

  container.innerHTML = allList.map(r => {
    const starString = '★'.repeat(r.rating) + '☆'.repeat(Math.max(0, 5 - r.rating));
    return `
      <div class="review-item-card">
        <div class="review-card-top">
          <div class="review-card-author">
            <span class="author-name">${escapeHtml(r.author)}</span>
            ${r.verified ? `<span class="verified-badge">✓ Verified Buyer</span>` : ''}
          </div>
          <div class="review-card-date">${escapeHtml(r.date)}</div>
        </div>
        <div class="review-card-stars">${starString}</div>
        <div class="review-card-headline">${escapeHtml(r.title)}</div>
        <div class="review-card-text">${escapeHtml(r.body)}</div>
      </div>
    `;
  }).join('');
}

function toggleReviewForm() {
  const wrap = document.getElementById('pdpReviewFormWrap');
  if (!wrap) return;
  if (wrap.style.display === 'none' || !wrap.style.display) {
    wrap.style.display = 'block';
    wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  } else {
    wrap.style.display = 'none';
  }
}

function setPickRating(rating) {
  currentReviewRating = rating;
  const stars = document.querySelectorAll('#starPicker .star-pick');
  stars.forEach(s => {
    const starVal = parseInt(s.getAttribute('data-star') || '1');
    if (starVal <= rating) {
      s.classList.add('active');
    } else {
      s.classList.remove('active');
    }
  });
}

function handleReviewSubmit(e) {
  e.preventDefault();
  if (!selectedProduct) return;

  const authorInput = document.getElementById('reviewAuthor');
  const titleInput = document.getElementById('reviewTitle');
  const bodyInput = document.getElementById('reviewBody');
  const verifiedCheck = document.getElementById('reviewVerifiedCheck');

  const newReview = {
    author: authorInput.value.trim() || 'Anonymous Collector',
    verified: verifiedCheck ? verifiedCheck.checked : true,
    rating: currentReviewRating || 5,
    date: 'Just now',
    title: titleInput.value.trim() || 'Verified Laroye Crown',
    body: bodyInput.value.trim()
  };

  try {
    const key = 'laroye_reviews_' + selectedProduct.id;
    let existing = [];
    const raw = localStorage.getItem(key);
    if (raw) existing = JSON.parse(raw);
    existing.unshift(newReview);
    localStorage.setItem(key, JSON.stringify(existing));
  } catch (err) {
    console.error('Error saving review to localStorage', err);
  }

  // Re-render reviews
  renderProductReviews(selectedProduct);

  // Reset form
  e.target.reset();
  setPickRating(5);
  toggleReviewForm();
  showToast('Thank you! Your product review has been published.');
}

function checkUrlHashForProduct() {
  const hash = window.location.hash;
  if (hash && hash.startsWith('#product-')) {
    const id = decodeURIComponent(hash.replace('#product-', ''));
    if (allProducts && allProducts.length > 0) {
      const p = allProducts.find(item => item.id === id || item.handle === id);
      if (p) {
        setTimeout(() => openProductModal(p.id), 250);
      }
    }
  }
}

function initPdpStickyScrollObserver() {
  const scrollBody = document.getElementById('pdpScrollBody');
  const stickyBar = document.getElementById('pdpStickyBar');
  const addBtn = document.getElementById('modalAddBtn');
  if (!scrollBody || !stickyBar || !addBtn) return;

  scrollBody.addEventListener('scroll', () => {
    const btnRect = addBtn.getBoundingClientRect();
    const modalRect = scrollBody.getBoundingClientRect();
    if (btnRect.bottom < modalRect.top + 60 || btnRect.top < 0) {
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }
  });
}

// ==========================================================================
// SHOPPING CART & NIKE-GRADE CHECKOUT
// ==========================================================================
function initCart() {
  try {
    const saved = localStorage.getItem('laroye_hats_cart');
    if (saved) cart = JSON.parse(saved);
  } catch (e) {
    cart = [];
  }
  updateCartUI();
}

function saveCart() {
  localStorage.setItem('laroye_hats_cart', JSON.stringify(cart));
  updateCartUI();
}

function quickAddToCart(productId, forcedSize) {
  const p = allProducts.find(item => item.id === productId);
  if (!p || !p.inStock) return;
  addToCart(p, forcedSize || p.sizes[0] || 'One Size');
}

function addCurrentModalToCart() {
  if (!selectedProduct || !selectedProduct.inStock) return;
  addToCart(selectedProduct, selectedSize);
  closeProductModal();
}

function expressCheckoutCurrentModal() {
  if (!selectedProduct || !selectedProduct.inStock) return;
  addToCart(selectedProduct, selectedSize);
  closeProductModal();
  proceedToCheckout();
}

function addToCart(product, size) {
  const key = `${product.id}_${size}`;
  const existing = cart.find(item => item.key === key);
  const isPresale = isItemPresale(product);

  // Match exact Shopify variant ID for selected size
  let matchedVariantId = product.variantId;
  if (Array.isArray(product.variants) && product.variants.length > 0) {
    const matched = product.variants.find(v => v.title && v.title.toLowerCase() === (size || '').toLowerCase());
    if (matched && matched.id) {
      matchedVariantId = matched.id;
    }
  }

  if (existing) {
    existing.quantity += 1;
  } else {
    cart.push({
      key: key,
      id: product.id,
      variantId: matchedVariantId,
      name: product.name,
      brand: product.brand,
      size: size,
      price: product.price,
      img: product.img,
      isPresale: isPresale,
      quantity: 1
    });
  }

  saveCart();
  showToast(isPresale ? `Pre-Sale Added: ${product.name} (Final Sale)` : `Added ${product.name} to Cart`);
  openCartDrawer();
}

function updateCartQty(key, delta) {
  const item = cart.find(i => i.key === key);
  if (!item) return;

  item.quantity += delta;
  if (item.quantity <= 0) {
    cart = cart.filter(i => i.key !== key);
  }
  saveCart();
}

function removeCartItem(key) {
  cart = cart.filter(i => i.key !== key);
  saveCart();
}

function applyCartPromo() {
  const input = document.getElementById('cartPromoInput');
  const feedback = document.getElementById('cartPromoFeedback');
  if (!input || !feedback) return;

  const code = input.value.trim().toUpperCase();
  if (!code) {
    feedback.textContent = 'Please enter a promo or VIP code.';
    feedback.className = 'cart-promo-feedback error';
    return;
  }

  if (code === 'LAROYE10' || code === 'WELCOME10') {
    cartDiscountPct = 0.10;
    appliedPromoCode = code;
    feedback.textContent = `Promo code "${code}" applied (10% OFF)!`;
    feedback.className = 'cart-promo-feedback success';
  } else if (code === 'VIPCROWN' || code === 'DANIELVIP') {
    cartDiscountPct = 0.15;
    appliedPromoCode = code;
    feedback.textContent = `VIP code "${code}" applied (15% OFF)!`;
    feedback.className = 'cart-promo-feedback success';
  } else {
    feedback.textContent = `Code "${code}" is invalid or expired.`;
    feedback.className = 'cart-promo-feedback error';
    return;
  }

  updateCartUI();
}

function removeCartPromo() {
  cartDiscountPct = 0;
  appliedPromoCode = '';
  const input = document.getElementById('cartPromoInput');
  const feedback = document.getElementById('cartPromoFeedback');
  if (input) input.value = '';
  if (feedback) {
    feedback.textContent = '';
    feedback.className = 'cart-promo-feedback';
  }
  updateCartUI();
}

function updateCartUI() {
  const totalCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  const badge = document.getElementById('cartCountBadge');
  if (badge) badge.textContent = totalCount;

  const container = document.getElementById('cartItemsContainer') || document.getElementById('cartItemsList');
  const emptyView = document.getElementById('cartEmptyView');
  const footer = document.getElementById('cartFooter') || document.querySelector('.cart-footer') || document.querySelector('.cart-drawer-footer');

  if (!container) return;

  if (cart.length === 0) {
    container.innerHTML = '';
    if (emptyView) emptyView.style.display = 'block';
    if (footer) footer.style.display = 'none';
    updateShippingMeter(0);
    return;
  }

  if (emptyView) emptyView.style.display = 'none';
  if (footer) footer.style.display = 'block';

  let subtotal = 0;
  container.innerHTML = cart.map(item => {
    const itemTotal = item.price * item.quantity;
    subtotal += itemTotal;
    const safeKey = item.key.replace(/'/g, "\\'");

    return `
      <div class="cart-item ${item.isPresale ? 'is-presale' : ''}">
        <img class="cart-item-img" src="${item.img}" alt="${escapeHtml(item.name)}">
        <div class="cart-item-info">
          <div style="display: flex; align-items: center; justify-content: space-between; gap: 4px;">
            <h4 class="cart-item-title">${escapeHtml(item.name)}</h4>
            ${item.isPresale ? `<span class="cart-presale-pill">PRE-SALE</span>` : ''}
          </div>
          <div class="cart-item-variant">Size: ${escapeHtml(item.size)}</div>
          ${item.isPresale ? `<div class="cart-presale-notice-text">⚠️ Final Sale &bull; No Cancellations or Returns</div>` : ''}
          <div class="cart-item-price">$${itemTotal.toFixed(2)}</div>
          <div class="cart-item-controls">
            <div class="qty-counter">
              <button class="qty-btn" onclick="updateCartQty('${safeKey}', -1)">-</button>
              <span class="qty-display">${item.quantity}</span>
              <button class="qty-btn" onclick="updateCartQty('${safeKey}', 1)">+</button>
            </div>
            <span class="item-remove-btn" onclick="removeCartItem('${safeKey}')">Remove</span>
          </div>
        </div>
      </div>
    `;
  }).join('');

  // Itemized Calculations
  const discountAmt = subtotal * cartDiscountPct;
  const isFreeShip = subtotal >= CONFIG.freeShippingThreshold;
  const shippingAmt = isFreeShip ? 0 : (subtotal > 0 ? 9.99 : 0);
  const finalTotal = Math.max(0, subtotal - discountAmt + shippingAmt);

  // Update Itemized Summary Table
  const subtotalValEl = document.getElementById('cartSubtotalVal');
  if (subtotalValEl) subtotalValEl.textContent = `$${subtotal.toFixed(2)}`;

  const discountRow = document.getElementById('cartDiscountRow');
  const discountValEl = document.getElementById('cartDiscountVal');
  if (discountRow && discountValEl) {
    if (discountAmt > 0) {
      discountRow.style.display = 'flex';
      discountValEl.innerHTML = `-$${discountAmt.toFixed(2)} (${appliedPromoCode}) <button type="button" onclick="removeCartPromo()" style="background:none;border:none;color:#ef4444;font-size:11px;cursor:pointer;margin-left:8px;text-decoration:underline;padding:0;" title="Remove discount">Remove</button>`;
    } else {
      discountRow.style.display = 'none';
    }
  }

  const shippingValEl = document.getElementById('cartShippingVal');
  if (shippingValEl) {
    if (isFreeShip) {
      shippingValEl.textContent = 'FREE';
      shippingValEl.className = 'cart-free-tag';
    } else {
      shippingValEl.textContent = `$${shippingAmt.toFixed(2)}`;
      shippingValEl.className = '';
    }
  }

  const totalEl = document.getElementById('cartTotalValue') || document.getElementById('cartSubtotalPrice');
  if (totalEl) totalEl.textContent = `$${finalTotal.toFixed(2)}`;

  updateShippingMeter(subtotal);

  // Pre-Sale Policy Alert in Cart Drawer
  const hasPresale = cart.some(i => i.isPresale);
  let presaleAlert = document.getElementById('cartPresaleAlert');
  if (!presaleAlert && footer) {
    presaleAlert = document.createElement('div');
    presaleAlert.id = 'cartPresaleAlert';
    footer.insertBefore(presaleAlert, footer.firstChild);
  }
  if (presaleAlert) {
    if (hasPresale) {
      presaleAlert.className = 'cart-presale-alert-box active';
      presaleAlert.innerHTML = `
        <div class="alert-header">
          <span class="alert-icon">⚠️</span>
          <strong>PRE-SALE ITEM POLICY NOTICE</strong>
        </div>
        <p class="alert-desc">
          Your cart contains <strong>Pre-Sale</strong> item(s). Pre-sale pieces are custom-manufactured to order. <u>Strictly no cancellations, refunds, or returns apply</u>. All sales are final.
        </p>
      `;
    } else {
      presaleAlert.className = 'cart-presale-alert-box';
      presaleAlert.innerHTML = '';
    }
  }
}

function updateShippingMeter(subtotal) {
  const threshold = CONFIG.freeShippingThreshold;
  const fill = document.getElementById('shippingProgressFill');
  const text = document.getElementById('shippingMeterText');
  if (!fill || !text) return;

  if (subtotal >= threshold) {
    fill.style.width = '100%';
    text.innerHTML = `<span>🔥 YOU QUALIFIED FOR FREE SHIPPING!</span><span>$0.00</span>`;
  } else {
    const diff = (threshold - subtotal).toFixed(2);
    const pct = Math.min(100, Math.round((subtotal / threshold) * 100));
    fill.style.width = `${pct}%`;
    text.innerHTML = `<span>Add <strong>$${diff}</strong> more for Free Shipping</span><span>${pct}%</span>`;
  }
}

function openCartDrawer() {
  const overlay = document.getElementById('cartDrawerOverlay') || document.getElementById('cartBackdrop');
  if (overlay) overlay.classList.add('open');
  const drawer = document.getElementById('cartDrawer');
  if (drawer) drawer.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const overlay = document.getElementById('cartDrawerOverlay') || document.getElementById('cartBackdrop');
  if (overlay) overlay.classList.remove('open');
  const drawer = document.getElementById('cartDrawer');
  if (drawer) drawer.classList.remove('open');
  document.body.style.overflow = '';
}

function proceedToCheckout() {
  if (cart.length === 0) return;
  const hasPresale = cart.some(i => i.isPresale);
  const btn = document.getElementById('checkoutBtn');
  if (btn) {
    btn.disabled = true;
    btn.textContent = hasPresale ? 'ROUTING TO SHOPIFY (FINAL SALE)...' : 'ROUTING TO SHOPIFY CHECKOUT...';
  }

  if (window.ShopifyClient) {
    window.ShopifyClient.createCheckout(cart, appliedPromoCode).finally(() => {
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'CHECKOUT →';
      }
    });
  } else {
    setTimeout(() => {
      alert(
        hasPresale
          ? "🔒 SECURE CHECKOUT READY\n\n⚠️ IMPORTANT PRE-SALE POLICY:\nYour order contains custom Pre-Sale items. All pre-sale items are strictly FINAL SALE with NO CANCELLATIONS OR RETURNS once placed.\n\nProceeding to Shopify gateway..."
          : "🔒 SECURE CHECKOUT READY\n\nAll Laroye Hats drops are limited edition and strictly FINAL SALE.\n\nProceeding to Shopify gateway..."
      );
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'CHECKOUT →';
      }
    }, 400);
  }
}


// ==========================================================================
// EVENT LISTENERS & MOBILE AUTO-DISMISS
// ==========================================================================
function initEventListeners() {
  // Sort Selector
  const sortSel = document.getElementById('sortSelect');
  if (sortSel) {
    sortSel.addEventListener('change', (e) => {
      currentSort = e.target.value;
      currentPage = 1;
      applyFilterAndRender();
    });
  }

  // Brand Selector
  const brandSel = document.getElementById('brandSelect');
  if (brandSel) {
    brandSel.addEventListener('change', (e) => {
      selectBrand(e.target.value);
    });
  }

  // Desktop Hat Types Dropdown Trigger
  const navDropdownBtn = document.getElementById('navDropdownBtn');
  const navHatDropdown = document.getElementById('navHatTypesDropdown');
  if (navDropdownBtn && navHatDropdown) {
    navDropdownBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      navHatDropdown.classList.toggle('open');
      const isExpanded = navHatDropdown.classList.contains('open');
      navDropdownBtn.setAttribute('aria-expanded', isExpanded);
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('#navHatTypesDropdown')) {
        navHatDropdown.classList.remove('open');
        navDropdownBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Search Input (Unlocks catalog when user searches)
  const searchInput = document.getElementById('searchInput');
  const searchSuggest = document.getElementById('searchResultsDropdown');
  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      searchQuery = e.target.value.trim();
      currentPage = 1;
      if (searchQuery.length > 0) {
        isSamplerMode = false;
        const shopSec = document.getElementById('shop-sec');
        const collectionsSec = document.getElementById('collections');
        if (shopSec) shopSec.classList.add('revealed');
        if (collectionsSec) collectionsSec.classList.add('revealed');
        const labelEl = document.getElementById('filterIndicatorLabel');
        if (labelEl) labelEl.textContent = `Search results for: "${searchQuery}"`;
      }
      applyFilterAndRender();
      renderSearchSuggestions(searchQuery);
    });

    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        searchSuggest.classList.remove('show');
        scrollToCatalogTop();
      }
    });
  }

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.search-container') && !e.target.closest('.search-box-wrap')) {
      const sg = document.getElementById('searchResultsDropdown');
      if (sg) sg.classList.remove('show');
    }

    // Modal backdrop click to dismiss
    const pModal = document.getElementById('productModal');
    if (pModal && e.target === pModal) {
      closeProductModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeProductModal();
      closeCartDrawer();
      closePolicyModal();
      if (navHatDropdown) {
        navHatDropdown.classList.remove('open');
        if (navDropdownBtn) navDropdownBtn.setAttribute('aria-expanded', 'false');
      }
      const sg = document.getElementById('searchResultsDropdown');
      if (sg) sg.classList.remove('show');
    }
  });

  // Mobile Drawer (Auto-Dismiss)
  const mobileToggle = document.getElementById('mobileNavToggle');
  const mobileDrawer = document.getElementById('mobileNavDrawer');
  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', () => {
      mobileToggle.classList.toggle('open');
      mobileDrawer.classList.toggle('open');
      document.body.style.overflow = mobileDrawer.classList.contains('open') ? 'hidden' : '';
    });

    document.querySelectorAll('.mobile-nav-drawer a').forEach(link => {
      link.addEventListener('click', () => {
        closeMobileMenu();
      });
    });
  }

  window.closeMobileMenu = function() {
    if (mobileToggle) mobileToggle.classList.remove('open');
    if (mobileDrawer) mobileDrawer.classList.remove('open');
    document.body.style.overflow = '';
  };

  // Initialize PDP Mobile Sticky Action Bar Scroll Observer
  initPdpStickyScrollObserver();

  // Handle URL Hash changes (Back/Forward browser buttons)
  window.addEventListener('hashchange', () => {
    const hash = window.location.hash;
    if (hash && hash.startsWith('#product-')) {
      checkUrlHashForProduct();
    } else if (!hash || hash === '#' || hash === '#shop-sec' || hash === '#about') {
      closeProductModal();
    }
  });
}

function renderSearchSuggestions(query) {
  const dropdown = document.getElementById('searchResultsDropdown');
  if (!dropdown) return;

  if (!query || query.length < 2) {
    dropdown.classList.remove('show');
    dropdown.innerHTML = '';
    return;
  }

  const qLower = query.toLowerCase();
  const matches = allProducts.filter(p => 
    p.name.toLowerCase().includes(qLower) || 
    p.brand.toLowerCase().includes(qLower) ||
    (p.hatType && p.hatType.toLowerCase().includes(qLower)) ||
    (Array.isArray(p.tags) && p.tags.some(t => t.toLowerCase().includes(qLower)))
  ).slice(0, 5);

  if (matches.length === 0) {
    dropdown.innerHTML = `<div style="padding:12px;color:var(--text-muted);font-size:12px;text-align:center;">No matching caps found</div>`;
  } else {
    dropdown.innerHTML = matches.map(p => {
      const safeId = p.id.replace(/'/g, "\\'");
      return `
        <div class="search-result-item" onclick="openProductModal('${safeId}'); document.getElementById('searchResultsDropdown').classList.remove('show');">
          <img src="${p.img}" alt="${escapeHtml(p.name)}">
          <div class="search-result-info">
            <div class="search-result-title">${escapeHtml(p.name)}</div>
            <div class="search-result-price">$${p.price.toFixed(2)}</div>
          </div>
        </div>
      `;
    }).join('');
  }
  dropdown.classList.add('show');
}

function resetFilters() {
  searchQuery = '';
  currentTag = 'all';
  const searchInput = document.getElementById('searchInput');
  if (searchInput) searchInput.value = '';
  selectStyle('all');
}

function showToast(msg) {
  const t = document.getElementById('toastNotification');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2400);
}

function escapeHtml(str) {
  if (!str) return '';
  return str.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
}

// ==========================================================================
// OFFICIAL SHOPIFY POLICIES MODAL
// ==========================================================================
function openPolicyModal(tabKey) {
  const modal = document.getElementById('policyModal');
  if (!modal) return;
  modal.classList.add('open');
  if (tabKey) {
    switchPolicyTab(tabKey);
  }
  document.body.style.overflow = 'hidden';
}

function closePolicyModal() {
  const modal = document.getElementById('policyModal');
  if (!modal) return;
  modal.classList.remove('open');
  document.body.style.overflow = '';
}

function switchPolicyTab(tabKey) {
  const btns = document.querySelectorAll('.policy-tab-btn');
  btns.forEach(btn => {
    if (btn.getAttribute('data-tab') === tabKey) {
      btn.classList.add('active');
      try {
        btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } catch (err) {}
    } else {
      btn.classList.remove('active');
    }
  });

  const panes = document.querySelectorAll('.policy-pane');
  panes.forEach(pane => {
    if (pane.id === `pane-${tabKey}`) {
      pane.classList.add('active');
    } else {
      pane.classList.remove('active');
    }
  });

  const contentArea = document.querySelector('.policy-content-area');
  if (contentArea) contentArea.scrollTop = 0;
}

function handlePolicyModalBackdrop(event) {
  if (event.target.id === 'policyModal') {
    closePolicyModal();
  }
}

// Window Global Exports
window.openProductModal = openProductModal;
window.closeProductModal = closeProductModal;
window.switchModalImage = switchModalImage;
window.selectModalSize = selectModalSize;
window.togglePdpAccordion = togglePdpAccordion;
window.openSizeGuideAccordion = openSizeGuideAccordion;
window.scrollToPdpSection = scrollToPdpSection;
window.shareCurrentProduct = shareCurrentProduct;
window.toggleReviewForm = toggleReviewForm;
window.setPickRating = setPickRating;
window.handleReviewSubmit = handleReviewSubmit;
window.applyCartPromo = applyCartPromo;
window.removeCartPromo = removeCartPromo;
window.expressCheckoutCurrentModal = expressCheckoutCurrentModal;
window.addCurrentModalToCart = addCurrentModalToCart;
window.quickAddToCart = quickAddToCart;
window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;
window.proceedToCheckout = proceedToCheckout;
window.updateCartQty = updateCartQty;
window.removeCartItem = removeCartItem;

window.openPolicyModal = openPolicyModal;
window.closePolicyModal = closePolicyModal;
window.switchPolicyTab = switchPolicyTab;
window.handlePolicyModalBackdrop = handlePolicyModalBackdrop;

